var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBluePlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.625 10H4.375V5.625H0V4.375H4.375V0H5.625V4.375H10V5.625H5.625V10Z",
  fill: "#4585FF"
})));
export default SvgIconBluePlus;